export const checkTimestamp = (timestamp: number): number => {
  if (timestamp === 0) {
    return 0.1;
  }

  return timestamp;
};
